import { useState } from 'react';
import imgUrl from './Image.jpg';
import style from './BackgroundImage.scss';
const { rootClassName } = style;
export default function BackgroundImage() {
  const [opacity, setOpacity] = useState(0);
  return (
    <svg
      className={rootClassName}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 -2 707 805'
    >
      <defs>
        <clipPath id='pena'>
          <path d='M259.5 0C107.5 171.5 0.5 566 0.5 804.5L707 802.5V1.5L259.5 0Z' />
        </clipPath>
      </defs>
      <g height='100%'>
        <image style={{ opacity }} href={imgUrl} onLoad={() => setOpacity(1)} />
      </g>
    </svg>
  );
}
